export const EXPORT_FILE_NAME = "PDF Snake Exported Steps.json";
export const EXPORT_KIND = EXPORT_FILE_NAME;